import { z } from 'zod';

export const SurgeonDtoSchema = z.object({
  id: z.string(),
  firstName: z.string().nullable().optional(),
  lastName: z.string().nullable().optional(),
  fullName: z.string().nullable().optional(),
  npiNumber: z.string().nullable().optional(),
  specialty: z.string().nullable().optional(),
  providerId: z.coerce.string().nullable().optional(),
  isActive: z.boolean().nullable().optional(),
});
export type SurgeonDto = z.infer<typeof SurgeonDtoSchema>;

export const PaginatedSurgeonsResponseDtoSchema = z.object({
  data: z.array(SurgeonDtoSchema),
  total: z.number(),
  page: z.number(),
  limit: z.number(),
});
export type PaginatedSurgeonsResponseDto = z.infer<typeof PaginatedSurgeonsResponseDtoSchema>;

export interface SurgeonsFilterParams {
  search?: string;
  page?: number;
  limit?: number;
}

export interface CreateSurgeonDto {
  firstName: string;
  lastName: string;
  fullName: string;
  npiNumber: string;
  specialty: string;
  providerId?: number;
  isActive?: boolean;
}

export interface UpdateSurgeonDto {
  firstName?: string;
  lastName?: string;
  fullName?: string;
  specialty?: string;
  providerId?: number | null;
  isActive?: boolean;
}
